export const dareEndpointIds = {
    DELIVERY_DARE: 'DELIVERY_DARE',
    COMPLETE_DARE: 'COMPLETE_DARE',
    GET_ADMIN_CREATOR_EVENT_FULFILLED_DARES: 'GET_ADMIN_CREATOR_EVENT_FULFILLED_DARES',
};
export const ACCEPT_DARE_ERROR_CODE_MAP = {
    AUTH_PLATFORM_NOT_CONNECTED: 'AUTH_PLATFORM_NOT_CONNECTED',
    CREATOR_PLATFORM_NOT_CONNECTED: 'CREATOR_PLATFORM_NOT_CONNECTED',
};
